
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "../../Components/Checkbox.js";
import { ReceiverVisibilityType, ReceiverVisibilityUpdate } from "../../Shared/CustomerConfigurationUpdate.js";
import { Msg } from "./Types.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { safeHash, equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { InformationAlert } from "../../Components/Alert.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { AppVariant, Variant } from "../../Variant.js";
import { empty as empty_1, append as append_1, contains, map, filter, singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ReceiverTypeName } from "../../Shared/User.js";
import { TextValue } from "../../Components/Text.js";
import { SystemRoleSettingsDto } from "../../Shared/Roles.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export function ReceiverActivationConfiguration(props) {
    let elems_1, elems;
    const patternInput = useTranslation();
    const config = props.CustomerConfiguration.ReceiverVisibilityConfiguration;
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const receiverCheckbox = (label, testId, receiverType, isChecked) => Checkbox({
        ComponentState: componentState,
        IsChecked: isChecked,
        Label: patternInput[0](label),
        OnCheck: (value) => {
            props.Dispatch(new Msg(0, [new ReceiverVisibilityUpdate(receiverType, value)]));
        },
        TestId: testId,
    });
    return reactElement("div", createObj(singleton_1((elems_1 = [createElement(InformationAlert, {
        Label: "settings.receivers_description",
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems = toList(delay(() => append(singleton(receiverCheckbox("receivers.users", "receiver-type-users-checkbox", new ReceiverVisibilityType(8, []), config.Users)), delay(() => append(singleton(receiverCheckbox("receivers.employees", "receiver-type-employees-checkbox", new ReceiverVisibilityType(1, []), config.Employees)), delay(() => append(singleton(receiverCheckbox("receivers.constructionsites", "receiver-type-constructionsites-checkbox", new ReceiverVisibilityType(0, []), config.ConstructionSites)), delay(() => append(singleton(receiverCheckbox("receivers.projects", "receiver-type-projects-checkbox", new ReceiverVisibilityType(3, []), config.Projects)), delay(() => append(singleton(receiverCheckbox("receivers.rooms", "receiver-type-rooms-checkbox", new ReceiverVisibilityType(4, []), config.Rooms)), delay(() => append(singleton(receiverCheckbox("receivers.externalpersons", "receiver-type-externalpersons-checkbox", new ReceiverVisibilityType(2, []), config.ExternalPersons)), delay(() => append(singleton(receiverCheckbox("receivers.subcontractors", "receiver-type-subcontractors-checkbox", new ReceiverVisibilityType(7, []), config.Subcontractos)), delay(() => append(equals(Variant, new AppVariant(1, [])) ? append(singleton(receiverCheckbox("receivers.school_classes", "receiver-type-school-classes-checkbox", new ReceiverVisibilityType(5, []), config.SchoolClasses)), delay(() => singleton(receiverCheckbox("receivers.students", "receiver-type-students-checkbox", new ReceiverVisibilityType(6, []), config.Students)))) : empty(), delay(() => singleton(receiverCheckbox("receivers.vehicles", "receiver-type-vehicles-checkbox", new ReceiverVisibilityType(9, []), config.Vehicles)))))))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))]))));
}

function isReceiverTypeActive(configuration, receiverType) {
    switch (receiverType.tag) {
        case 1:
            return configuration.Employees;
        case 6:
            return configuration.ConstructionSites;
        case 5:
            return configuration.Projects;
        case 4:
            return configuration.Rooms;
        case 2:
            return configuration.ExternalPersons;
        case 3:
            return configuration.Subcontractos;
        case 8:
            if (equals(Variant, new AppVariant(1, []))) {
                return configuration.SchoolClasses;
            }
            else {
                return false;
            }
        case 7:
            if (equals(Variant, new AppVariant(1, []))) {
                return configuration.Students;
            }
            else {
                return false;
            }
        case 9:
            if (equals(Variant, new AppVariant(1, []))) {
                return configuration.Vehicles;
            }
            else {
                return false;
            }
        case 10:
            return false;
        default:
            return configuration.Users;
    }
}

function receiverTypeLabel(receiverType) {
    switch (receiverType.tag) {
        case 1:
            return "receivers.employees";
        case 6:
            return "receivers.constructionsites";
        case 5:
            return "receivers.projects";
        case 4:
            return "receivers.rooms";
        case 2:
            return "receivers.externalpersons";
        case 3:
            return "receivers.subcontractors";
        case 8:
            return "receivers.school_classes";
        case 7:
            return "receivers.students";
        case 9:
            return "receivers.vehicles";
        case 10:
            return "receivers.api_receivers";
        default:
            return "receivers.users";
    }
}

function reservationTestId(receiverType) {
    switch (receiverType.tag) {
        case 1:
            return "employees";
        case 6:
            return "constructionsites";
        case 5:
            return "projects";
        case 4:
            return "rooms";
        case 2:
            return "externalpersons";
        case 3:
            return "subcontractors";
        case 8:
            return "school_classes";
        case 7:
            return "students";
        case 9:
            return "vehicles";
        case 10:
            return "api_receivers";
        default:
            return "users";
    }
}

function toolManagerTestId(receiverType) {
    switch (receiverType.tag) {
        case 1:
            return "employee";
        case 6:
            return "construction-site";
        case 5:
            return "project";
        case 4:
            return "room";
        case 2:
            return "external-person";
        case 3:
            return "subcontractor";
        case 8:
            return "school-class";
        case 7:
            return "student";
        case 9:
            return "vehicle";
        case 10:
            return "api-receiver";
        default:
            return "user";
    }
}

const reservationReceiverTypes = ofArray([new ReceiverTypeName(0, []), new ReceiverTypeName(1, []), new ReceiverTypeName(6, []), new ReceiverTypeName(5, []), new ReceiverTypeName(4, []), new ReceiverTypeName(2, []), new ReceiverTypeName(3, []), new ReceiverTypeName(8, []), new ReceiverTypeName(7, []), new ReceiverTypeName(9, [])]);

const toolManagerReceiverTypes = filter((receiverType) => !equals(receiverType, new ReceiverTypeName(0, [])), reservationReceiverTypes);

function ReceiverTypeSelection(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = [createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t(props.Title),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems = map((receiverType) => {
        let Label;
        return Checkbox((Label = t(receiverTypeLabel(receiverType)), {
            ComponentState: props.ComponentState,
            IsChecked: contains(receiverType, props.Selected, {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            }),
            Label: Label,
            OnCheck: (value_2) => {
                props.OnChange(append_1(value_2 ? singleton_1(receiverType) : empty_1(), filter((selected) => !equals(selected, receiverType), props.Selected)));
            },
            TestId: props.TestId(receiverType),
        }));
    }, props.ReceiverTypes), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function SystemRoleReceiverSettings(props) {
    const activeTypes = (receiverTypes) => filter((receiverType) => isReceiverTypeActive(props.CustomerConfiguration.ReceiverVisibilityConfiguration, receiverType), receiverTypes);
    const settings = props.RoleSettings.Settings;
    const componentState = props.RoleSettings.FormState.IsLoading ? "disabled" : "enabled";
    const xs = toList(delay(() => append(singleton(createElement(ReceiverTypeSelection, {
        ComponentState: componentState,
        OnChange: (receiverTypes_1) => {
            props.RoleSettings.OnUpdate((settings_1) => (new SystemRoleSettingsDto(settings_1.ToolManagerReceiverWriteTypes, settings_1.ToolManagerReceiverArchiveTypes, settings_1.ToolManagerCanDeleteInventory, settings_1.ToolManagerCanSeeCommercialData, settings_1.UserCanSeeAllInventory, settings_1.UserCanSeeCommercialData, settings_1.UserCanWriteNotices, settings_1.UserCanReserveForSelf, settings_1.UserReservationReceiverTypes, receiverTypes_1, settings_1.AllRolesReceiveNotificationEmails, settings_1.UserCanUseGlobalAppSearch, settings_1.AssignToUserViaSelection)));
        },
        ReceiverTypes: activeTypes(reservationReceiverTypes),
        Selected: settings.UserVisibleReceiverTypes,
        TestId: (receiverType_1) => concat("receiver-visibility-", ...toolManagerTestId(receiverType_1)),
        Title: "settings.permissions_app_receiver_visibility",
    })), delay(() => append(singleton(createElement(ReceiverTypeSelection, {
        ComponentState: settings.UserCanReserveForSelf ? componentState : "disabled",
        OnChange: (receiverTypes_2) => {
            props.RoleSettings.OnUpdate((settings_2) => (new SystemRoleSettingsDto(settings_2.ToolManagerReceiverWriteTypes, settings_2.ToolManagerReceiverArchiveTypes, settings_2.ToolManagerCanDeleteInventory, settings_2.ToolManagerCanSeeCommercialData, settings_2.UserCanSeeAllInventory, settings_2.UserCanSeeCommercialData, settings_2.UserCanWriteNotices, settings_2.UserCanReserveForSelf, receiverTypes_2, settings_2.UserVisibleReceiverTypes, settings_2.AllRolesReceiveNotificationEmails, settings_2.UserCanUseGlobalAppSearch, settings_2.AssignToUserViaSelection)));
        },
        ReceiverTypes: activeTypes(reservationReceiverTypes),
        Selected: settings.UserReservationReceiverTypes,
        TestId: (receiverType_2) => concat("create-reservation-checkbox-", ...reservationTestId(receiverType_2)),
        Title: "settings.permissions_receiver_create_reservation_permission",
    })), delay(() => append(singleton(createElement(ReceiverTypeSelection, {
        ComponentState: componentState,
        OnChange: (receiverTypes_3) => {
            props.RoleSettings.OnUpdate((settings_3) => (new SystemRoleSettingsDto(receiverTypes_3, settings_3.ToolManagerReceiverArchiveTypes, settings_3.ToolManagerCanDeleteInventory, settings_3.ToolManagerCanSeeCommercialData, settings_3.UserCanSeeAllInventory, settings_3.UserCanSeeCommercialData, settings_3.UserCanWriteNotices, settings_3.UserCanReserveForSelf, settings_3.UserReservationReceiverTypes, settings_3.UserVisibleReceiverTypes, settings_3.AllRolesReceiveNotificationEmails, settings_3.UserCanUseGlobalAppSearch, settings_3.AssignToUserViaSelection)));
        },
        ReceiverTypes: activeTypes(toolManagerReceiverTypes),
        Selected: settings.ToolManagerReceiverWriteTypes,
        TestId: (receiverType_3) => concat("can-tool-manager-create-", ...toolManagerTestId(receiverType_3)),
        Title: "settings.permissions_can_tool_manager_create_receiver",
    })), delay(() => (isFeatureEnabled(new Feature(6, [])) ? singleton(createElement(ReceiverTypeSelection, {
        ComponentState: componentState,
        OnChange: (receiverTypes_4) => {
            props.RoleSettings.OnUpdate((settings_4) => (new SystemRoleSettingsDto(settings_4.ToolManagerReceiverWriteTypes, receiverTypes_4, settings_4.ToolManagerCanDeleteInventory, settings_4.ToolManagerCanSeeCommercialData, settings_4.UserCanSeeAllInventory, settings_4.UserCanSeeCommercialData, settings_4.UserCanWriteNotices, settings_4.UserCanReserveForSelf, settings_4.UserReservationReceiverTypes, settings_4.UserVisibleReceiverTypes, settings_4.AllRolesReceiveNotificationEmails, settings_4.UserCanUseGlobalAppSearch, settings_4.AssignToUserViaSelection)));
        },
        ReceiverTypes: activeTypes(toolManagerReceiverTypes),
        Selected: settings.ToolManagerReceiverArchiveTypes,
        TestId: (receiverType_4) => concat("can-tool-manager-archive-", ...toolManagerTestId(receiverType_4)),
        Title: "settings.permissions_can_tool_manager_archive_receiver",
    })) : empty())))))))));
    return react.createElement(react.Fragment, {}, ...xs);
}

export function ReceiverSettings(props) {
    let elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.CustomerConfiguration;
    if (matchValue.tag === 0) {
        return defaultOf();
    }
    else {
        const customerConfiguration = matchValue.fields[0];
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems = toList(delay(() => append(singleton(createElement(ReceiverActivationConfiguration, {
            CustomerConfiguration: customerConfiguration,
            Dispatch: patternInput[1],
            FormState: state_1.FormState,
        })), delay(() => {
            const matchValue_1 = props.SystemRoleSettings;
            if (matchValue_1 == null) {
                return empty();
            }
            else {
                return singleton(createElement(SystemRoleReceiverSettings, {
                    CustomerConfiguration: customerConfiguration,
                    RoleSettings: matchValue_1,
                }));
            }
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

